import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VoTableContainerComponent} from './vo-table-container/vo-table-container.component';
import {NgxDatatableModule} from "@almaobservatory/ngx-datatable";
import { VoTableColumnHeaderContainerComponent } from './column-header/vo-table-column-header-container/vo-table-column-header-container.component';
import { VoTableColumnHeaderFilterInputComponent } from './column-header/vo-table-column-header-filter-input/vo-table-column-header-filter-input.component';
import {NgbPopoverModule, NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {FormsModule} from "@angular/forms";
import {SearchTableModule} from "../search-table/search-table.module";
import { VoTableColumnFilterComponent } from './column-filters/vo-table-column-filter/vo-table-column-filter.component';
import {NgTruncatePipeModule} from "angular-pipes";


@NgModule({
  declarations: [
    VoTableContainerComponent,
    VoTableColumnHeaderContainerComponent,
    VoTableColumnHeaderFilterInputComponent,
    VoTableColumnFilterComponent
  ],
  exports: [
    VoTableContainerComponent
  ],
    imports: [
        CommonModule,
        NgxDatatableModule,
        NgbTooltipModule,
        FormsModule,
        NgbPopoverModule,
        SearchTableModule,
        NgTruncatePipeModule
    ]
})
export class VoTableModule {
}
